import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  YEARS_FILTER_REQUEST,
  YEARS_FILTER_SUCCESS,
  YEARS_FILTER_FAILURE,
  YEARS_FILTER_CLEAR,
  YEARS_FILTER_DELETE,
  YEARS_FILTER_SET,
  YEARS_FILTER_UPDATE,
} from 'app/actions/reports/filters/years';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const years = (state = defaultState, { type, payload }) => {
  switch (type) {
    case YEARS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case YEARS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case YEARS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case YEARS_FILTER_CLEAR: {
      return defaultState;
    }
    case YEARS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case YEARS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case YEARS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default years;
